import { atom } from "jotai";
import { ICanvas, ICanvasElement, IMarketingPanel, MarketingPanelLayout } from "@Eikochain/components/organisms/MarketingEditor/types";

export const selectedElementIdAtom = atom<number | null>(null);
export const elementsForCurrentCanvasAtom = atom<ICanvasElement[]>([]);
export const currentPanelAtom = atom<IMarketingPanel | null>(null);
